import { connect } from 'react-redux'
import elementContainerSelector from './elementContainerSelector'
import ElementContainer from './ElementContainer'

export default connect(
  elementContainerSelector,
  {},
  null,
  {
    forwardRef: true,
  }
)(ElementContainer)
